import { render, staticRenderFns } from "./Registerj.vue?vue&type=template&id=f88212c8&scoped=true&"
import script from "./Registerj.vue?vue&type=script&lang=js&"
export * from "./Registerj.vue?vue&type=script&lang=js&"
import style0 from "./Registerj.vue?vue&type=style&index=0&id=f88212c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88212c8",
  null
  
)

export default component.exports